__webpack_require__.p = "/VoiceOver-Portfolio/";